'use client';
import React, { SyntheticEvent, UIEventHandler, useEffect, useRef } from 'react';

import styles from './styles.module.scss';

interface Props {
  rootClassName?: string;
  className?: string;
  blur?: boolean;
  aurora?: boolean;
  onClick?: (e: React.MouseEvent<HTMLDivElement>) => void;
  onMouseOver?: () => void;
  onMouseOut?: () => void;
  onScroll?: (e: SyntheticEvent<HTMLDivElement>) => void;
  children?: React.ReactNode;
  clipAnimationDuration?: string;
}

const Container = (props: Props) => {
  const {
    rootClassName = '',
    className = '',
    blur = false,
    aurora = false,
    onClick,
    onMouseOver,
    onMouseOut,
    onScroll,
    clipAnimationDuration = '',
    children,
  } = props;
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    // clipAnimationDuration이 설정된 경우 애니메이션 시간을 설정
    if(!ref.current || !clipAnimationDuration) return;

    ref.current.style.setProperty('--duration', clipAnimationDuration);
  }, [ref, clipAnimationDuration]);

  return <>
    <div
      ref={ref}
      className={`${styles.container} ${blur ? 'blur' : ''} ${aurora ? styles.outline : ''} ${clipAnimationDuration ? styles.animateClip : ''} ${rootClassName} `}
      onClick={onClick}
      onMouseOver={onMouseOver}
      onMouseOut={onMouseOut}
    >
      <div className={`${styles.inner} ${className}`} onScroll={onScroll}>
        {children}
      </div>
    </div>
  </>;
};

export default Container;